export function formatFullName(name: string): string {
  if (name.length < 18) return name;
  const words = name.split(" ");
  const firstName = words.slice(0, words.length - 1).join(" ");
  const lastName = words[words.length - 1].charAt(0);
  return `${firstName} ${lastName}`;
}
